/**
 * "Sigue bajando para comprar": corrige el salto del PRIMER clic.
 *
 * El enlace nativo (href="#comprar") con scroll-behavior:smooth (ver base.css) calcula
 * el destino UNA vez, al empezar a moverse, y no lo vuelve a recalcular mientras la
 * animación de scroll está en marcha. Si algo desplaza el layout DURANTE esa animación
 * -normalmente las tipografías web (@font-face, font-display:swap en
 * assets/kotashi-marca.css) terminando de cargar y cambiando el alto del texto de más
 * arriba- el destino real ya no está donde el navegador apuntaba, y aterrizas más abajo
 * de la cuenta. En la segunda pulsación las fuentes ya están cargadas y no pasa nada, por
 * eso solo falla la primera vez.
 *
 * Arreglo: en vez de dejar el scroll nativo suelto, se hace el scroll suave a mano y, al
 * terminar (evento "scrollend" si el navegador lo soporta; si no, un margen de tiempo de
 * sobra), se comprueba si el destino sigue en su sitio y, si no, se corrige con un
 * segundo scroll instantáneo. Invisible cuando todo va bien (no hace nada extra); solo
 * actúa cuando de verdad ha habido un desplazamiento de layout de por medio.
 */
(() => {
  document.querySelectorAll('a[href^="#"].kotashi-pasos__continuar').forEach((enlace) => {
    enlace.addEventListener('click', (evento) => {
      const destino = document.querySelector(enlace.getAttribute('href'));
      if (!destino) return;

      evento.preventDefault();
      destino.scrollIntoView({ behavior: 'smooth', block: 'start' });

      let corregido = false;
      const corregir = () => {
        if (corregido) return;
        corregido = true;
        const rect = destino.getBoundingClientRect();
        // scroll-margin-top ya lo tiene en cuenta el propio scrollIntoView; un margen de
        // unos pocos píxeles es normal (subpíxel/redondeo), más que eso es el bug real.
        if (Math.abs(rect.top) > 4) {
          destino.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      };

      if ('onscrollend' in window) {
        window.addEventListener('scrollend', corregir, { once: true });
      } else {
        setTimeout(corregir, 900);
      }
    });
  });
})();
